import React from 'react';
import Header from '../components/Header';
import bgtrace from '../assets/bgtrace1.jpeg';

const FAQ = () => {
  return (
    <div className="min-h-screen">
      <Header />
      
      <main 
        className="pt-20 pb-16 px-4 sm:px-6 lg:px-8"
        style={{
          backgroundImage: `url(${bgtrace})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed'
        }}
      >
        <div className="text-center pt-20 pb-10">
          <h1 className="text-5xl font-extrabold">
            Frequently Asked <span className="text-red-600">Questions</span>
          </h1>
          <p className="mt-4 text-gray-700 max-w-2xl mx-auto">
            Here are some common questions our customers ask. More FAQs will be added soon.
          </p>
        </div>

        <div className="max-w-4xl mx-auto bg-white/95 text-gray-900 shadow-xl rounded-xl p-10 mt-6 mb-20 backdrop-blur-sm">
          <div className="space-y-8">
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">What vehicles do you support?</h2>
              <p className="mt-2 text-gray-800">
                We specialize in Toyota trucks and SUVs. More vehicle compatibility information will be added soon.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">Do you offer installation services?</h2>
              <p className="mt-2 text-gray-800">
                Yes, installation services are available at our Chula Vista location. You can request an installation on our Contact page.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">Do you accept returns?</h2>
              <p className="mt-2 text-gray-800">
                Most unused items in original packaging can be returned within 30 days. For more details, visit our Returns policy or contact us directly.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">When will more FAQs be added?</h2>
              <p className="mt-2 text-gray-800">
                This FAQ section is a work in progress. More information will be added as our team expands this resource.
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default FAQ;

